

















import PlaceList from '@/components/PlaceList.vue';
import Vue from 'vue';
import { api } from '@/services/api';

export default Vue.extend({
    name: 'NearbyPlacesView',

    components: {
        PlaceList,
    },

    data() {
        return {
            location: null,
            places: null,
        };
    },

    computed: {
        lat() {
            return this.$route.params.latlon.split(',')[0];
        },
        lon() {
            return this.$route.params.latlon.split(',')[1];
        },
    },

    created() {
        api.get(
            'places/near',
            {
                lat: this.lat,
                lon: this.lon,
            },
        ).then((response) => {
            this.places = response.places;
            this.location = response.location;
        });
    },
});
